import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isProfilingEnabled } from '@src/app/core/utils/feature-flags.util';
import { AuthSelectors } from '@src/app/store/auth/auth.selectors';
import { combineLatest, filter, map, take } from 'rxjs';

/**
 * Guard que protege rutas exclusivas para Poseedores Finales Integrales (PFI).
 *
 * Comportamiento:
 * - Si VIEW_PF=false (perfilado desactivado): redirige a /services mediante UrlTree.
 * - Si VIEW_PF=true (perfilado activo): espera a que selectedCompany esté cargado
 *   en el store (evita falsos negativos en recarga) y luego comprueba selectIsPoseedorFinalIntegral.
 *   - true  → permite acceso
 *   - false → redirige a /services mediante UrlTree
 *
 * NOTA: Se usa UrlTree (router.createUrlTree) en lugar del patrón
 * router.navigate() + return false para evitar condiciones de carrera
 * con efectos NgRx que observan cambios de navegación.
 */
export const poseedorFinalIntegralGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!isProfilingEnabled()) {
    return router.createUrlTree(['/services']);
  }

  const store = inject(Store);

  return combineLatest([
    store.select(AuthSelectors.selectSelectedCompany),
    store.select(AuthSelectors.selectIsPoseedorFinalIntegral),
  ]).pipe(
    filter(([company]) => !!company?.TIPO_TERCERO),
    take(1),
    map(([, isPFI]) => {
      if (isPFI) {
        return true;
      }
      return router.createUrlTree(['/services']);
    }),
  );
};
